import { render } from "./HomeContractAddition.vue?vue&type=template&id=f2e0b358"
import script from "./HomeContractAddition.vue?vue&type=script&lang=js"
export * from "./HomeContractAddition.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_mypuregym\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__